/**
 * RFC-149: StepCard — numbered step (1/2/3) with title and description.
 */
import type { ReactNode } from 'react';
import { MotionReveal } from './MotionReveal';

interface StepCardProps {
  number: number | string;
  title: ReactNode;
  description: ReactNode;
  delayMs?: number;
  className?: string;
}

export function StepCard({ number, title, description, delayMs, className }: StepCardProps) {
  return (
    <MotionReveal delayMs={delayMs} className={`text-center ${className ?? ''}`}>
      <div className="w-14 h-14 rounded-2xl gradient-primary flex items-center justify-center mx-auto mb-4">
        <span className="text-xl font-bold text-primary-foreground">{number}</span>
      </div>
      <h3 className="text-xl font-semibold mb-3">{title}</h3>
      <p className="text-muted-foreground leading-relaxed">{description}</p>
    </MotionReveal>
  );
}
